import type { FC, PropsWithChildren } from 'react'

import { Group, Text } from '@mantine/core'
import { MoveLeft } from 'lucide-react'
import Link from 'next/link'

import { routes } from '@/constants/routes'

const LinkBackLogin: FC<PropsWithChildren> = (props) => {
  const { children } = props

  return (
    <Link href={routes.login} style={{ textAlign: 'center', textDecoration: 'none' }}>
      <Group justify='center' gap={8}>
        <MoveLeft color='var(--mantine-color-text-secondary)' size={16} strokeWidth={1} />
        <Text c='var(--mantine-color-text-secondary)' size='xs'>
          {children}
        </Text>
      </Group>
    </Link>
  )
}

export default LinkBackLogin
